import React from 'react';
import { RouterProvider, createBrowserRouter, Navigate } from 'react-router-dom';
import { UserProvider } from './context/UserContext';
import { router } from './routes';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { AuthManager } from './components/Auth/AuthManager';
import Login from './components/Login/Login';
import Register from './components/SignUp/Signup';

const publicRouter = createBrowserRouter([
  {
    path: '/',
    element: <Login />
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/register',
    element: <Register />
  },
  {
    path: '*',
    element: <Navigate to="/" replace />
  }
]);

function App() {
  return (
      <AuthManager>
        {({ session, loading }) => {
          if (loading) {
            return <div>Loading...</div>;
          }

          if (!session) {
            return (
              <>
                <RouterProvider router={publicRouter} />
              </>
            );
          }
          
          return (
            <>
              <UserProvider>
                  <RouterProvider router={router} />
                  <ToastContainer />
              </UserProvider>
            </>
          );
        }}
      </AuthManager>
  );
}

export default App;